import React from 'react';
import {
  Datagrid,
  BooleanField,
  FunctionField,
  Pagination,
  TextField,
  useListController,
  ListContextProvider,
  ResourceContextProvider,
  useRecordContext
} from 'react-admin';

import { EventInviteActions } from './EventInviteActions.tsx';
import { Box, Chip } from '@mui/material';

type AttendanceMode = 'IN_PERSON' | 'ZOOM' | 'NO_SHOW';

const ATTENDANCE_MODE_LABEL: Record<AttendanceMode, string> = {
  IN_PERSON: 'In Person',
  ZOOM: 'Zoom',
  NO_SHOW: 'No-Show'
};

const ATTENDANCE_MODE_COLOR: Record<
  AttendanceMode,
  'success' | 'info' | 'default'
> = {
  IN_PERSON: 'success',
  ZOOM: 'info',
  NO_SHOW: 'default'
};

export const PaginatedEventInvites: React.FC = () => {
  const resource = 'group-event-invites';

  const event = useRecordContext();
  const eventId = event?.id; // ← use it directly

  const controller = useListController({
    resource,
    filter: { eventId },
    sort: { field: 'contactName', order: 'ASC' },
    perPage: 10,
    disableSyncWithLocation: true
  });

  return (
    <ResourceContextProvider value={resource}>
      <ListContextProvider value={controller}>
        <Box width="100%">
          <Datagrid bulkActionButtons={false} empty={<></>}>
            <TextField source="contactName" label="Name" />
            <BooleanField source="registered" label="Registered" />
            <BooleanField source="attended" label="Attended" />
            <FunctionField
              label="How"
              source="attendanceMode"
              render={(record: { attendanceMode?: AttendanceMode | null }) => {
                const mode = record?.attendanceMode;
                if (!mode) return null;
                return (
                  <Chip
                    label={ATTENDANCE_MODE_LABEL[mode]}
                    size="small"
                    color={ATTENDANCE_MODE_COLOR[mode]}
                    variant="outlined"
                  />
                );
              }}
            />
            <EventInviteActions />
          </Datagrid>
          <Pagination />
        </Box>
      </ListContextProvider>
    </ResourceContextProvider>
  );
};
